import { z } from 'zod';
export const SearchSchema = z.object({
  pageIndex: z.coerce.number().int().min(0).catch(0),
  pageSize: z.coerce.number().int().min(1).max(100).catch(20),
  scope: z.enum(['self']).catch('self')
});